/** The header, its menus and the other chrome around every dashboard page. */
export const shell = {
    skipToMain: "Skip to main content",
    homeLink: "OPC UA Relay by Sterfive - dashboard home",
    account: {
        menu: "Account menu",
        menuFor: "Account menu for {name}",
        settings: "Settings",
        signOut: "Sign Out",
    },
    help: {
        label: "Help",
        heading: "Need help?",
        documentation: "Documentation",
        support: "Support Site",
        contact: "Contact us",
        version: "Version",
        versionUnknown: "Version unknown",
    },
    theme: {
        current: "Theme: {current}. Switch to {next}",
        light: "light",
        dark: "dark",
        system: "system",
    },
    organisation: {
        label: "Organisation",
        personal: "{name} (personal)",
        withSlug: "{name} ({slug})",
        trigger: "Organisation: {name}",
        manage: "Manage organisation",
        switched: "Switched to {name}",
        switchFailed: "Could not switch organisation.\n{message}",
    },
};
